import s from "./generateUtilityClasses.mjs";
import e from "./generateUtilityClass.mjs";
function n(t) {
  return e("MuiListItemIcon", t);
}
const i = s("MuiListItemIcon", ["root", "alignItemsFlexStart"]), a = i;
export {
  a as default,
  n as getListItemIconUtilityClass
};
//# sourceMappingURL=listItemIconClasses.mjs.map
